import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clock",
  "use": "icon-clock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-clock\"><path d=\"M512.001 1024c-282.774 0-512-229.228-512-512C0 229.228 229.226 0 512 0c282.772 0 511.998 229.227 511.998 512 0 282.772-229.228 512-511.998 512zm0-959c-246.866 0-447 200.136-447 447C65 758.864 265.134 959 512 959c246.864 0 447.002-200.137 447.002-447 0-246.864-200.137-447-447.001-447zm-30 480l-1-351h63v319L742 679l-39 55-221-189z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol